import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { TostMessageProvider } from './context/TostMessage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <TostMessageProvider>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <PayPalScriptProvider options={{ "client-id": "Ab19q1-JfQlalR3hpGrCjB_ZYW_fhiSESMf2hlwONmD01esqu7ykcsClh83DMwuGFRElJeFwPPLDKqQr", currency: 'GBP' }}>
            <App />
          </PayPalScriptProvider>
        </CookiesProvider>
      </TostMessageProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
